import Segments, { ISegment } from 'components/Segments';
import { segmentSelectionCopy } from 'data';
import { SectionTextWrapper } from 'styles/global.styles';

import React from 'react';
import styled from 'styled-components';

interface ISegmentSection {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleSegmentClick: (index: number) => void;
  data: ISegment[];
  disabled: boolean;
}

const SegmentSection = (props: ISegmentSection): JSX.Element => {
  return (
    <Wrapper>
      <SectionTextWrapper
        sectionNumber={2}
        heading={segmentSelectionCopy.heading}
        description={segmentSelectionCopy.description}
      />

      <Segments
        onSelect={(index) => props.handleSegmentClick(index)}
        data={props.data}
        onClick={props.onClick}
        disabled={props.disabled}
      />
    </Wrapper>
  );
};

export default SegmentSection;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 2rem;
`;
